<h1 mat-dialog-title>Confirm archive of link(s)</h1>
<mat-dialog-content>
    <p>Are you certain you want to archive {{ count }} links?</p>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false">Cancel</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">Archive</button>
</mat-dialog-actions>
